module.exports = __webpack_public_path__ + "static/ruby-7938d2da5567ea6426912c882f720b87.png";